import { CommentFormWrapper } from './CommentFormWrapper'

import './styles.modules.scss'

export default CommentFormWrapper
